import { Line } from '@react-three/drei';
import * as THREE from 'three';

/**
 * Always-on-top draw overlay, mirroring the Distance Measurement tool
 * (MeasurementLine): a dark outline behind a bright core, rendered with
 * depthTest/depthWrite off and a high renderOrder so the preview is visible even
 * when drawing over the model surface.
 */
const OUTLINE = '#1A1A1A';

const RENDER_ORDER = {
  LINE_OUTLINE: 997,
  LINE_CORE: 998,
  POINT_OUTLINE: 999,
  POINT_CORE: 1000,
} as const;

export function OverlayLine({
  points,
  color,
  width = 2,
}: {
  points: THREE.Vector3[];
  color: string;
  width?: number;
}): JSX.Element | null {
  if (points.length < 2) return null;
  return (
    <group>
      <Line
        points={points}
        color={OUTLINE}
        lineWidth={width + 2.5}
        depthTest={false}
        depthWrite={false}
        transparent
        renderOrder={RENDER_ORDER.LINE_OUTLINE}
        raycast={() => null}
      />
      <Line
        points={points}
        color={color}
        lineWidth={width}
        depthTest={false}
        depthWrite={false}
        transparent
        renderOrder={RENDER_ORDER.LINE_CORE}
        raycast={() => null}
      />
    </group>
  );
}

export function OverlayPoint({
  position,
  color,
  radius = 0.16,
}: {
  position: THREE.Vector3;
  color: string;
  radius?: number;
}): JSX.Element {
  return (
    <group position={position}>
      <mesh renderOrder={RENDER_ORDER.POINT_OUTLINE} raycast={() => null}>
        <sphereGeometry args={[radius * 1.4, 16, 16]} />
        <meshBasicMaterial color={OUTLINE} depthTest={false} depthWrite={false} transparent />
      </mesh>
      <mesh renderOrder={RENDER_ORDER.POINT_CORE} raycast={() => null}>
        <sphereGeometry args={[radius, 16, 16]} />
        <meshBasicMaterial color={color} depthTest={false} depthWrite={false} transparent />
      </mesh>
    </group>
  );
}
